// extracted by mini-css-extract-plugin
module.exports = {"summaryTable":"Summary_summaryTable__2aD_y"};